export default "__VITE_ASSET__CJPY8qaS__"